// eslint-disable-next-line no-shadow
export enum AuthProcess {
	SIGN_IN = 'sign_in',
	INITIALISE_USER = 'initialise_user',
}
